import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import {
  getAllModGroupsWithDescriptions,
  getValidCartItems,
} from '../utils/cart';
import { selectIsExpressUpsellSuppressionActive } from './menu';
import {
  selectHasCheckTotal,
  selectPromptAskCounts,
  selectPromptOverrides,
  selectWithheldConstraints,
} from '../redux/features/experiments/experiments.selector';

const selectCart = (state: RootState) => state.cart;
const selectCartModality = createSelector(selectCart, (cart) => cart.modality);
const selectCartItems = createSelector(selectCart, (cart) => cart.cartItems);
const selectCartItemsQuantity = createSelector(
  selectCart,
  (cart) => cart.cartItemsQuantity
);

const selectValidCartItems = createSelector(selectCartItems, (cartItems) =>
  getValidCartItems(cartItems)
);
const selectHypothesisCartItems = createSelector(
  selectCart,
  (cart) => cart.hypothesisCartItems
);

const selectCartLoyalties = createSelector(
  selectCart,
  (cart) => cart.loyalties
);

// Reads both express triggers (meal period OR elapsed timer): reading only the
// meal-period half let the timer offer a tagged prompt it had declined
// everywhere else (HITL-1806).
const selectModGroupsWithDescriptions = createSelector(
  selectCartItems,
  selectIsExpressUpsellSuppressionActive,
  selectWithheldConstraints,
  selectPromptOverrides,
  selectPromptAskCounts,
  selectHasCheckTotal,
  (
    cartItems,
    isExpressUpsellSuppressionActive,
    withheldConstraints,
    prompts,
    promptAskCounts,
    hasCheckTotal
  ) =>
    getAllModGroupsWithDescriptions(
      cartItems,
      isExpressUpsellSuppressionActive,
      {
        withheldConstraints,
        prompts,
        promptAskCounts,
        hasCheckTotal,
      }
    )
);

export {
  selectCart,
  selectCartItems,
  selectCartItemsQuantity,
  selectCartModality,
  selectValidCartItems,
  selectHypothesisCartItems,
  selectCartLoyalties,
  selectModGroupsWithDescriptions,
};
